import { Component, OnInit, ViewChild,Inject,OnDestroy } from '@angular/core';
import { MatSort, MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import {  StaffDesignationList, StaffGroupList, StaffByIDparam, getStaffbyid } from './staff';
import { StaffService } from './staff.service';
import { HomeService } from '../home/home.service';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import {appsettings} from '../../app-settings';
import { AddStaffComponent } from './add-staff/add-staff.component';
import { EditStaffComponent } from './edit-staff/edit-staff.component';
import { DeleteStaffComponent } from './delete-staff/delete-staff.component';
import { DownloadStaffComponent } from './download-staff/download-staff.component';
import { enumUIFeatureView, enumUIAction, enumUIView, enumStaffRoll } from '../../app-settings';
import { ShowStaffGroupComponent } from './show-staff-group/show-staff-group.component';
import { MainLayoutService } from '../../main-layout/main-layout.service';
import { SidenavComponent } from '../../main-layout/sidenav/sidenav.component';
import { InfrastructureAlertsComponent } from '../../main-layout/alerts/infrastructure-alerts/infrastructure-alerts.component';
import { RollbarService } from '../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheckwithStaff,checkStaffData, getFeatureNeedtoShow, getAddEditDeleteColumn,AuthFailedMessage, generateAlertMessage } from '../../app-general';
import {Router} from '@angular/router';
import { ApiService } from '../../api.service';
import { SharedCheckIsAlertReportData, Staff, MapSyncProcess, getStaffData } from '../../api';
import { AlertSharedService } from '../../_services/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  providers: [ StaffService ],  
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit,OnDestroy {

  Staffs: Staff[];
  staffDesignationList: StaffDesignationList[];
  staffGroupList: StaffGroupList[];
  Staffbyid : getStaffbyid[];
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  bGroupView:boolean=false;
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  displayedColumns: string[] = ['photo', 'Name', 'TagId', 'RoomName', 'Designation', 'Phone', 'Email','GroupName', 'edit', 'delete'];
  dataSource;
  downloadstaffSource;
  dataSourcecount;
  IsRefreshNeed = 1;

  staffImgUrl:string = appsettings.STAFF_FOLDER;
  chksearchvalue;
  StaffId;
  staffsortedData = [];
  staffloading = true;
  SiteId = "1";
  Stafflength;
  checklivestaffdata;  
  Logged_RoleID = 0;
  staff_MapSyncProcess;
  interval_staff;
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,private staffService: StaffService,private mediaObserver: MediaObserver,  @Inject(RollbarService) private rollbar: Rollbar,public dialog: MatDialog, 
  public mainLayoutService: MainLayoutService,private apiService: ApiService,private alertSharedService: AlertSharedService,private homeService: HomeService) {

      mediaObserver.media$.subscribe((change: MediaChange) => {
        if (getFeatureNeedtoShow(enumUIFeatureView.Staff, enumUIAction.Staff_AddEditDelete) == enumUIView.Show) {
          this.bAddEdit = true;
          this.bDelete = true;
        }
        
        if (getFeatureNeedtoShow(enumUIFeatureView.Staff_Group, enumUIAction.Staff_Group_View) == enumUIView.Show) {
          this.bGroupView = true;
        }
        
          if (change.mqAlias == this.xscurrentScreenWidth) {
              this.setupTableforXtrasmallerwidth();
          }
          else if (change.mqAlias == this.smcurrentScreenWidth) {
              this.setupTableforsmallerwidth();
          }
          else
          {
            this.setupFullTable();
          }	
        });
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {   
    if (getFeatureNeedtoShow(enumUIFeatureView.Staff, enumUIAction.Staff_View) != enumUIView.Show) {
      localStorage.clear();
      this.router.navigate(['/login']);
    }
    if (getFeatureNeedtoShow(enumUIFeatureView.Staff, enumUIAction.Staff_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }
    

    if (this.IsRefreshNeed == 1) {
      var ChkIsAlertReportChanged = true;
  
      this.alertSharedService.currentSharedCheckIsAlertReport().pipe(takeUntil(this._onDestroy)).subscribe((SharedCheckIsAlertReportDetails: SharedCheckIsAlertReportData) => {
        var CheckIsAlertReportDataChanged = SharedCheckIsAlertReportDetails;
        if (CheckIsAlertReportDataChanged != undefined) {
          if (CheckIsAlertReportDataChanged.IsAlertReportChanged == 1 && ChkIsAlertReportChanged) {
            ChkIsAlertReportChanged = false;
            
            setTimeout(() => {
              
              var liveItem = { SiteId: this.SiteId, AuthKey: localStorage.getItem("Authkey") }
              this.readLiveData(liveItem);
              this.checkStaffById();
              this.getStaffData();
            }, (1000 * 60 * 1));

            CheckIsAlertReportDataChanged.IsAlertReportChanged = 0;
            this.alertSharedService.changeSharedCheckIsAlertReport(CheckIsAlertReportDataChanged);
          }
          else if (CheckIsAlertReportDataChanged.IsAlertReportChanged == 0) {
            ChkIsAlertReportChanged = true;
          }
        }
      });
    }

      var liveItem = { SiteId: this.SiteId, AuthKey: localStorage.getItem("Authkey") }
      this.readLiveData(liveItem);
      this.checkStaffById();
      this.getStaffData();    


      this.StaffId = localStorage.getItem("userid");
      this.Logged_RoleID = parseInt(localStorage.getItem("role"));           
    }

  readLiveData(LiveItem) {  
      this.viewRoomData();
  }

  viewRoomData() {     
      var sReturn=getFeatureNeedtoShow(enumUIFeatureView.Location, enumUIAction.Location_RTLS_Staff);
      if (sReturn.toString()==enumUIView.Show.toString() )
      {
        this.checklivestaffdata='1';
      }
      else
      {
        this.checklivestaffdata='0';
      }
           
      var RoomIndex = this.displayedColumns.indexOf('RoomName');
      if (this.checklivestaffdata != undefined) {
        if (this.checklivestaffdata != '1') {
          if (RoomIndex >= 0) {
            this.displayedColumns.splice(RoomIndex, 1);
          }
        }
      }
    
  }

    checkStaffById()
    {  
        checkStaffData(this.apiService,this.alertSharedService);    
    }    

   setupTableforXtrasmallerwidth() {
        this.displayedColumns = ['Name', 'Designation', 'edit', 'delete'];
        this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete); 
    };

   setupTableforsmallerwidth() {
        this.displayedColumns = ['photo', 'Name', 'Designation', 'edit', 'delete'];
        this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete); 
    };

   setupFullTable() {
        this.displayedColumns = ['photo', 'Name', 'TagId','RoomName', 'Designation', 'Phone', 'Email','GroupName', 'edit', 'delete'];
        this.viewRoomData();
        this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);       
    };	   

    getStaffData(): void {
    try
    {  
      this.staffloading = true;  
     var staffItem : getStaffData = {authKey: localStorage.getItem("Authkey")}
        this.apiService.getStaffData(staffItem).pipe(takeUntil(this._onDestroy))
          .subscribe((Staffs : any[])=>{ 
            if(Staffs["apiReturn"] == "Invalid Auth Key")
            {                             
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            } 
            this.staffloading = false;          
            this.Staffs = Staffs["apiReturn"];
            this.Stafflength = Staffs["apiReturn"][0].MaxId;
            
            this.dataSource = new MatTableDataSource(this.Staffs);
            this.downloadstaffSource = new MatTableDataSource(this.Staffs);
            if(this.chksearchvalue == undefined)                  
            {
              this.dataSource.data = this.Staffs;
              this.downloadstaffSource.data = this.Staffs;
            }
            else
            {
              this.searchStaff(this.chksearchvalue);        
            }            
           
            setTimeout(() => { 
              this.staffsortedData = [];
              this.dataSource.sort = this.sort;
              this.sortingDatalist(this.dataSource);              
              this.downloadstaffSource.sort = this.sort;
              this.sortingDatalist(this.downloadstaffSource);             
              this.downloadstaffSource.connect().subscribe(data => this.staffsortedData = data); 
          }, 0);           
            this.dataSource.paginator = this.paginator;
            if(this.chksearchvalue == undefined)
                this.dataSourcecount= this.dataSource.data.length;  
            else
                this.dataSourcecount= this.dataSource.filteredData.length;   
                
          });
      }
      catch (err) {
        throw new Error('staff.component.ts' + ' - getStaffData() - ' + err.message);
      }
  }

  searchStaff(filterValue: string) {
    if (filterValue !=null)
    {
     
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.chksearchvalue = filterValue;
      this.dataSource.filter = filterValue; 
      this.searchfilter();      
      this.staffsortedData = this.dataSource.filteredData;
      this.dataSourcecount = this.dataSource.filteredData.length;
      setTimeout(() => {           
        this.dataSource.sort = this.sort;
        this.sortingDatalist(this.dataSource);       
        this.downloadstaffSource.sort = this.sort; 
        this.sortingDatalist(this.downloadstaffSource);         
        this.downloadstaffSource.connect().subscribe(data => this.staffsortedData = data);                    
     }, 0);  
    }
}

searchfilter()
{
  this.dataSource.filterPredicate = function(data, filter: string): boolean {   
    var filterinfo=filter.toLowerCase();
    return data.Name.toLowerCase().includes(filterinfo) || data.Email.toLowerCase().includes(filterinfo) || 
           data.TagId.toString().includes(filterinfo) || data.RoomName.toLowerCase().includes(filterinfo) || 
           data.GroupName.toLowerCase().includes(filterinfo) || data.Designation.toLowerCase().includes(filterinfo) ||
           data.Phone.toString().includes(filterinfo);
	   
  
  }; 
}

    /*********Opendialogwindow*******/
addStaffdata() {   
  if(!SessionCheckwithStaff(this.router))
  {   
      return;
  }  
  let stafflistelement = document.getElementById('divstaffdetails');
      stafflistelement.className = 'clsdisable';
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  }; 
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.staff_MapSyncProcess = MapSyncinfo;    
    if(this.staff_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let stafflistelement = document.getElementById('divstaffdetails');
          stafflistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      var Height;
      const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
      if(isIEOrEdge == true)
      {
        Height = '795px';
      }
      else
      {
        Height = '790px';
      }      
      let dialogRef = this.dialog.open(AddStaffComponent, {
        disableClose: true,
        width: '1200px',
        height: Height,
        panelClass: 'custom-modalbox',
        autoFocus: false,
        data:this.Stafflength
      });
      dialogRef.afterClosed().subscribe(result => {   
        let stafflistelement = document.getElementById('divstaffdetails');
            stafflistelement.className = 'clsenable'; 
        if(result == 'Confirm')
        {
          let element1 = document.getElementById('addstaff');
          element1.className = 'clsbuttonStaff mat-raised-button mat-primary ng-star-inserted';  
          this.getStaffData();      
        }
        else
        {
          let element1 = document.getElementById('addstaff');
          element1.className = 'clsbuttonStaff mat-raised-button mat-primary ng-star-inserted';           
        }
      })
    }
  })
}

editStaffdata(staffId : number) {   
  let stafflistelement = document.getElementById('divstaffdetails');
      stafflistelement.className = 'clsdisable';
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }  
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  }; 
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => {    
    this.staff_MapSyncProcess = MapSyncinfo  
    if(this.staff_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let stafflistelement = document.getElementById('divstaffdetails');
          stafflistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      let staffbyid: StaffByIDparam = {        
        authKey: localStorage.getItem("Authkey"),
        staffId : staffId
      }
      this.apiService.getStaffDataById(staffbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((StaffbyId : any[])=>{   
        this.Staffbyid = StaffbyId["apiReturn"];            
        this.editopendialog(this.Staffbyid)
      });   
    }
  })
}

editopendialog(Staffbyid){  
    var Height;
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
    if(isIEOrEdge == true)
    {
      Height = '795px';
    }
    else
    {
      Height = '790px';
    }
    let dialogRef = this.dialog.open(EditStaffComponent, {
      disableClose: true,
      width: '1200px',
      height: Height,
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: Staffbyid    
    });    
    dialogRef.afterClosed().subscribe(result => {   
      let stafflistelement = document.getElementById('divstaffdetails');
          stafflistelement.className = 'clsenable';            
      if(result != 'Cancel')
      {
        this.getStaffData();    
      }              
    }) 
}

deleteStaffdata(staffId : number) { 
  let stafflistelement = document.getElementById('divstaffdetails');
      stafflistelement.className = 'clsdisable';
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  }; 
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.staff_MapSyncProcess = MapSyncinfo  
    if(this.staff_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let stafflistelement = document.getElementById('divstaffdetails');
          stafflistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      let staffbyid: StaffByIDparam = {        
        authKey: localStorage.getItem("Authkey"),
        staffId : staffId
      }
      this.apiService.getStaffDataById(staffbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((StaffbyId : any[])=>{    
        this.Staffbyid = StaffbyId["apiReturn"];    
        this.deleteopendialog(this.Staffbyid)
      });  
    }
  })
}

deleteopendialog(Staffbyid){  
    let dialogRef = this.dialog.open(DeleteStaffComponent, {
      disableClose: true,
      width: '550px',
      height:'380px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: Staffbyid    
    });      
    dialogRef.afterClosed().subscribe(result => {  
      let stafflistelement = document.getElementById('divstaffdetails');
          stafflistelement.className = 'clsenable';       
      if(result == 'Confirm')
      {        
        this.getStaffData();      
      }
      
           
    })
  
}

downloadStaffdata()
{  
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  if(this.dataSource.filter != '')
  {
    this.downloadstaffSource.data = this.dataSource.filteredData;
    setTimeout(() => {        
      this.dataSource.sort = this.sort;  
      this.sortingDatalist(this.dataSource);     
      this.dataSource.connect().subscribe(data => this.staffsortedData = data);   
   }, 0);      
  }    
  var staffdata = this.staffsortedData;
  const dialogRef = this.dialog.open(DownloadStaffComponent, {
    disableClose: true,
    width: '388px',
    height: '165px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data: staffdata
  });
  dialogRef.afterClosed().subscribe(result => {
    let element1 = document.getElementById('downloadbtn');
    element1.className = 'clsbuttonStaff mat-raised-button mat-primary ng-star-inserted'; 
  });
}
///////////////ADD staff Group////////////
ClickStaffGroup() { 
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
    let dialogRef = this.dialog.open(ShowStaffGroupComponent, {
      disableClose: true,
      width: '700px',
      height:'390px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {  
      if(result == 'Cancel') 
      {
        let element1 = document.getElementById('staffgroup');
        element1.className = 'clsbuttonStaff mat-raised-button mat-primary ng-star-inserted';        
      }     
      else
      {
        let element1 = document.getElementById('staffgroup');
        element1.className = 'clsbuttonStaff mat-raised-button mat-primary ng-star-inserted';
        this.getStaffData(); 
      }
    })
  }

  sortingDatalist(DataSource)
  {
            DataSource.sortingDataAccessor = function(data, sortHeaderId: string) {               
                  if(sortHeaderId != 'TagId')
                  {               
                    return data[sortHeaderId].toString().toLocaleLowerCase().trim('');                
                  }   
                  else
                  {                
                    return data[sortHeaderId]; 
                  }                                    
              }
  }
  

  CloseRightNav(){  
    if(SidenavComponent.isClosed == false)
    {
        this.mainLayoutService.toggleSideNavRight.emit();
    }
    if(InfrastructureAlertsComponent.isinfraClosed == false)
    {
        this.mainLayoutService.toggleinfrastructureLeft.emit("close");
    }   
  }
  ngOnDestroy() {
    clearInterval(this.interval_staff);
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}

